/*
 *  ************************************************************************
 *  *  © [2015 - 2024] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { subscribeOnClickHandler } from "../../layout-utils";
import { getTextContrast } from "../../../../../utils";
import "./subscribe-button.m.css";
import get from "lodash.get";

export const SubscribeButton = ({
  defaultSubscriptionHandler,
  mode,
  member,
  plan,
  subscriptionConfig,
  sso,
  separator = true,
  sketchesHost,
  config
}) => {
  const { buttonColor, darkButtonColor, subscribeButton } = subscriptionConfig;
  const updatedButtonColor = mode === "dark" ? darkButtonColor : buttonColor;
  const subscribeButtonColor = getTextContrast(updatedButtonColor);
  const updatedButtonText = subscribeButton || "Subscribe Now";
  const whiteListedUrlParams = get(config, ["pagebuilder-config", "general", "others", "whiteListedUrlParams"], []);

  return (
    <div styleName={`button-wrapper ${mode}`} className="subscribe-button">
      <button
        styleName="subscribe"
        data-test-id="subscribe-button"
        onClick={(e) => subscribeOnClickHandler(e, plan, sso, member, defaultSubscriptionHandler, sketchesHost, whiteListedUrlParams)}
        style={
          updatedButtonColor
            ? { background: updatedButtonColor, color: subscribeButtonColor === "dark" ? "#000" : "#fff" }
            : {}
        }
      >
        {updatedButtonText}
      </button>
      {separator && <div styleName="separator" />}
    </div>
  );
};
